import { Button } from '@getro/rombo';
import PropTypes from 'prop-types';
import { useGetAPCAColor } from '../../hooks/useGetAPCAColor';

export const ApplyButton = ({ network, onApplyClick, applicationUrl, ...props }) => {
  const { accent, primary } = useGetAPCAColor(network);
  return (
    <Button
      as="a"
      variant="primary"
      sx={{
        backgroundColor: primary,
        border: 'none',
        '&:hover': {
          backgroundColor: primary,
          border: 'none',
        },
        div: {
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          color: `${accent} !important`,
        },
      }}
      width={['100%', '132px']}
      onClick={onApplyClick}
      href={applicationUrl}
      target="_blank"
      onAuxClick={onApplyClick}
      {...props}
    >
      Apply now
    </Button>
  );
};

ApplyButton.propTypes = {
  network: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onApplyClick: PropTypes.func.isRequired,
  applicationUrl: PropTypes.string.isRequired,
};

export default ApplyButton;
